import { render, staticRenderFns } from "./stops.vue?vue&type=template&id=51afba44"
import script from "./stops.vue?vue&type=script&lang=js"
export * from "./stops.vue?vue&type=script&lang=js"
import style0 from "./stops.vue?vue&type=style&index=0&id=51afba44&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports